<template>
  <Breadcrumbs
      title="Approval Console"
      :breadcrumbs="[
      { label: 'Administration', path: '' },
      { label: 'Approval Console', path: '/approval-console' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <ApprovalConsoleForm/>
    </div>
  </div>
</template>

<script>

import ApprovalConsoleForm from "@/pages/administration/approval_console/approvalConsoleForm.vue";

export default {
  components: {
    ApprovalConsoleForm
  }
}

</script>